import React, {useEffect, useState} from 'react';
import {Event} from "../GoogleAnalytics";
import {AxisTypes, Equipment, GraphTypes} from "../../componentObjects";
import AlertService from "../../services/alerts.service";
import PropTypes from "prop-types";
import GraphComponent from "../Graph/GraphComponent";
import CommonModal from "../CommonModal/CommonModal";
import IconButton from "@mui/material/IconButton";
import FullLoader from "../Loader/FullLoader";

function ExtendGraphButton(props) {
    const { currentAlert, currentAsset, currentType, currentRadio, buttonContent, acSelected, alert, graphAlertId, getGraphData, getSeriesMax, disabled, extendRightDisabled = false } = props;
    const [loading, setLoading] = useState(false);
    const [extendedLoading, setExtendedLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [showMessage, setShowMessage] = useState(false);
    const [alertData, setAlertData] = useState([]);
    const [extendDataList, setExtendDataList] = useState([]);
    const [chartDataList, setChartDataList] = useState([]);
    const [tstatDataList, setTstatDataList] = useState([]);
    const [dataMax, setDataMax] = useState(0);
    const [currentMax, setCurrentMax] = useState(0);
    const [rightHours, setRightHours] = useState(0);
    const [leftHours, setLeftHours] = useState(0);
    const [currentGraph, setCurrentGraph] = useState({});
    const [visibility, setVisibility] = useState({
        rla: false,
        lra: false,
        fla: false,
        thermostat: false
    });
    const [showGraphModal, setShowGraphModal] = useState(false);
    
    const doNothing = () => {
        
    }
    
    const onExtendDataLeft = async () => {
        let newLeftHours = leftHours + 1; //1 'hr' = 30 minutes
        setLeftHours(newLeftHours);
        setExtendedLoading(true);
        await getExtendedData(newLeftHours, rightHours, true);
    }

    const onExtendDataRight = async () => {
        let newRightHours = rightHours + 1;
        setRightHours(newRightHours);
        setExtendedLoading(true);
        await getExtendedData(leftHours, newRightHours, false);
    }

    const getExtendedData = async (leftHours, rightHours, extendLeft) => {
        let newDataList = extendDataList;
        let newChartDataList = chartDataList;
        let newTstatDataList = tstatDataList;
        
        let list = [];
        list = list.concat(alert);
        
        await AlertService.getalertrawdata(currentAsset.assetId, list, extendLeft ? leftHours : 0, extendLeft ? 0 : rightHours)
            .then(response => {
                let alertData = response.data;
                if (alertData[graphAlertId] === undefined || alertData[graphAlertId] === null) {
                    alertData[graphAlertId] = { color: '', series: [] };
                }

                let series = alertData[graphAlertId];
                newDataList = newDataList.concat(series);

                let seriesData = series.data;

                let dataName = `${alert.alertId}`;
                newChartDataList = extendGraphData(newChartDataList, dataName, seriesData, extendLeft);
                newTstatDataList = extendGraphData(newTstatDataList, dataName, seriesData, extendLeft);

                if (currentRadio === Equipment.AIR_CONDITIONER) {
                    newChartDataList = extendGraphData(newChartDataList, dataName + " " + Equipment.FURNACE, seriesData, extendLeft, 'furnaceValue');
                    newTstatDataList = extendGraphData(newChartDataList, dataName + " " + Equipment.FURNACE, seriesData, extendLeft, 'furnaceValue');
                }

                if (newTstatDataList.includes(t => t.name === dataName + " Indoor Temp")) {
                    newTstatDataList = extendGraphData(newTstatDataList, dataName + " Indoor Temp", seriesData, extendLeft, 'tstatIndoorTempValue');
                }
                if (newTstatDataList.includes(t => t.name === dataName + " Outdoor Temp")) {
                    newTstatDataList = extendGraphData(newTstatDataList, dataName + " Outdoor Temp", seriesData, extendLeft, 'tstatOutdoorTempValue');
                }
                if (newTstatDataList.includes(t => t.name === dataName + " Indoor Humidity")) {
                    newTstatDataList = extendGraphData(newTstatDataList, dataName + " Indoor Humidity", seriesData, extendLeft, 'indoorHumidityValue');
                }
                if (newTstatDataList.includes(t => t.name === dataName + " Outdoor Humidity")) {
                    newTstatDataList = extendGraphData(newTstatDataList, dataName + " Outdoor Humidity", seriesData, extendLeft, 'outdoorHumidityValue');
                }
                if (newTstatDataList.includes(t => t.name === dataName + " Cool Setpoint")) {
                    newTstatDataList = extendGraphData(newTstatDataList, dataName + " Cool Setpoint", seriesData, extendLeft, 'coolSetpointValue');
                }
                if (newTstatDataList.includes(t => t.name === dataName + " Heat Setpoint")) {
                    newTstatDataList = extendGraphData(newTstatDataList, dataName + " Heat Setpoint", seriesData, extendLeft, 'heatSetpointValue');
                }

                let dataMax = 0;
                for (let i = 0; i < newChartDataList.length; i++) {
                    if (newChartDataList[i].data.length > dataMax) {
                        dataMax = newChartDataList[i].data.length;
                    }
                }
                
                setLoading(false);
                setDataMax(dataMax);
                setExtendDataList(newDataList);
                setChartDataList(newChartDataList);
                setTstatDataList(newTstatDataList);
                setExtendedLoading(false);
                
            })
            .catch(e => {
                console.log(e);
                setLoading(false);
                setMessage("Failed to load graph data for extended alert!");
                setShowMessage(true);

                setTimeout(() => {
                    setMessage("");
                    setShowMessage(false);
                }, 3000);
            });
        
    }
    
    const extendGraphData = (dataList, dataName, seriesData, extendLeft, valueStr = "value") => {
        let existingDataObj = dataList.find(obj => obj.name === dataName);
        let existingIndex = dataList.indexOf(existingDataObj);
        let existingData = existingDataObj.data;
        let dataArr = seriesData.map((item) => (item[valueStr]));
        if (extendLeft) {
            existingData = dataArr.concat(existingData);
        }
        else {
            existingData = existingData.concat(dataArr);
        }
        existingDataObj.data = existingData;
        dataList[existingIndex] = existingDataObj;
        return dataList;
    }
    
    const onShowGraphModal = () => {
        setShowGraphModal(!showGraphModal);
        if (!showGraphModal) {
            setLeftHours(0);
            setRightHours(0);
        }
    }
    
    const openGraphModal = async () => {
        setLeftHours(0);
        setRightHours(0);
        setLoading(true);
        
        let dataList = [];
        let chartDataList = [];
        let tstatDataList = [];
        let list = [];
        list = list.concat(alert);

        await AlertService.getalertrawdata(currentAsset.assetId, list)
            .then(response => {
                let alertData = response.data;
                if (alertData[graphAlertId] === undefined || alertData[graphAlertId] === null) {
                    alertData[graphAlertId] = { color: '', series: [] };
                }
                alertData[graphAlertId].color = alertData[graphAlertId] !== undefined && alertData[graphAlertId] !== null ? alertData[graphAlertId].color : 'white';
                alertData[graphAlertId] = alertData[graphAlertId];

                let series = alertData[graphAlertId];
                dataList = dataList.concat(series);

                let seriesData = series.data;

                let seriesMax = 0;
                let currentMax = 0;
                let thisMax = seriesData.length;
                if (thisMax > seriesMax) {
                    seriesMax = thisMax;
                }

                const seriesMaxCurrent = getSeriesMax(seriesData);
                if (seriesMaxCurrent > currentMax) {
                    currentMax = seriesMaxCurrent;
                }

                let dataName = `${alert.alertId}`;
                let seriesRun = seriesData;
                chartDataList = getGraphData(chartDataList, dataName, seriesRun, series.color);
                tstatDataList = getGraphData(tstatDataList, dataName, seriesRun, series.color);

                if (currentRadio === Equipment.AIR_CONDITIONER) {
                    chartDataList = getGraphData(chartDataList, dataName + " " + Equipment.FURNACE, seriesRun, series.color, 'furnaceValue', 'longDash');
                    tstatDataList = getGraphData(tstatDataList, dataName + " " + Equipment.FURNACE, seriesRun, series.color, 'furnaceValue', 'longDash');
                }

                tstatDataList = getGraphData(tstatDataList, dataName + " Indoor Temp", seriesRun, series.color, 'tstatIndoorTempValue', 'longDashDotDot', null, 1);
                tstatDataList = getGraphData(tstatDataList, dataName + " Outdoor Temp", seriesRun, series.color, 'tstatOutdoorTempValue', 'longDashDot', null, 1);
                tstatDataList = getGraphData(tstatDataList, dataName + " Indoor Humidity", seriesRun, series.color, 'indoorHumidityValue', 'shortDash', null, 1);
                tstatDataList = getGraphData(tstatDataList, dataName + " Outdoor Humidity", seriesRun, series.color, 'outdoorHumidityValue', 'shortDashDot', null, 1);
                tstatDataList = getGraphData(tstatDataList, dataName + " Cool Setpoint", seriesRun, series.color, 'coolSetpointValue', 'shortDashDotDot', null, 1);
                tstatDataList = getGraphData(tstatDataList, dataName + " Heat Setpoint", seriesRun, series.color, 'heatSetpointValue', 'dot', null, 1);

                let dataMax = 0;
                if (seriesMax > dataMax) {
                    dataMax = seriesMax;
                }

                setLoading(false);
                setExtendDataList(dataList);
                setDataMax(dataMax);
                setCurrentMax(currentMax);
                setChartDataList(chartDataList);
                setTstatDataList(tstatDataList);
                setShowGraphModal(true);
                setExtendedLoading(false);

                if (currentRadio === Equipment.AIR_CONDITIONER && dataList.length) {
                    let rlaVal = dataList[0].rla;
                    let rlaMin = rlaVal - 5;
                    if (currentMax >= rlaMin) {
                        visibility.rla = true;
                        setVisibility(visibility);
                    }
                }
            })
            .catch(e => {
                console.log(e);
                setLoading(false);
                setMessage("Failed to load graph data for selected alert!");
                setShowMessage(true);

                setTimeout(() => {
                    setMessage("");
                    setShowMessage(false);
                }, 3000);
            });
    }
    
    let graphButton = <div>
        <button className="graph-btn-triage secondary-btn btn-small" disabled={disabled} onClick={() => openGraphModal(currentAlert, currentAsset)}>
            {buttonContent}
        </button>
    </div>;
    let extendedLeftButton = <div className={"extended-icon extended-left col-sm-1 col-md-1"}>
        <IconButton onClick={onExtendDataLeft}>
            <i className={"fa-solid fa-arrow-left extended-color"}></i>
        </IconButton>
    </div>
    let extendedRightButton = <div className={"extended-icon extended-right col-sm-1 col-md-1"}>
        <IconButton onClick={onExtendDataRight} disabled={extendRightDisabled}>
            <i className={extendRightDisabled ? "fa-solid fa-arrow-right" : "fa-solid fa-arrow-right extended-color"}></i>
        </IconButton>
    </div>;
        
    let graphContent = <div className={"margin-top-10 row"}>
        {extendedLeftButton}
        <div className="col-md-10">
            <div className="highlight-bar-charts" >
                <GraphComponent graphType={GraphTypes.ALERT} chartData={visibility.thermostat ? tstatDataList : chartDataList} key={`extended-${chartDataList.length}-${extendDataList.length}-${visibility}`} assetType={currentRadio === "AirConditioner" ? Equipment.AIR_CONDITIONER : Equipment.FURNACE}
                                               currentMax={currentMax} dataMax={dataMax} rawMax={0} rawData={[]} last150Data={[]} rlaValue={extendDataList.length ? extendDataList[0].rla : null}
                                               visibility={visibility} lraValue={extendDataList.length ? extendDataList[0].lra : null} flaValue={extendDataList.length ? extendDataList[0].fla : null} alertList={[alert]}
                                               assetId={currentAsset.assetId} setLoading={setLoading} secondAxisType={visibility.thermostat ? AxisTypes.TEMP : AxisTypes.NONE} isExtendedOnly={true}
                                        />
            </div>
        </div>
        {extendedRightButton}
    </div>;
    let graphModal = <CommonModal show={showGraphModal} title={"Extended Graph"} content={graphContent} onClick={onShowGraphModal} onYes={doNothing} loading={extendedLoading}/>

    let loader = loading ? <FullLoader /> : null;
    
    return (
        <div>
            {loader}
            {graphButton}
            {graphModal}
        </div>
    )
}

ExtendGraphButton.propTypes = {
    currentAlert: PropTypes.object,
    currentAsset: PropTypes.object,
    currentType: PropTypes.string,
    currentRadio: PropTypes.string,
    buttonContent: PropTypes.any,
    acSelected: PropTypes.bool,
    alert: PropTypes.object,
    graphAlertId: PropTypes.any,
    getGraphData: PropTypes.func,
    getSeriesMax: PropTypes.func,
    disabled: PropTypes.bool
}
export default ExtendGraphButton;